import React, { useState, useRef, useEffect } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import Calendar from "../../Components/Calendar";
import {
  Dropdown,
  ButtonRadio,
  Button,
  Loading,
  Dialog,
} from "../../Components/Bootstrap";
import { Card, Stack } from "react-bootstrap";
/** Styles Import */
import "react-calendar/dist/Calendar.css";

function Holiday() {
  const [loading, setLoading] = useState(false);
  const [dateValue, setDateValue] = useState(new Date()); // 캘린더 선택 시 저장되는 변수
  const [holidayList, setHolidayList] = useState([]); // 현재 등록된 휴가 데이터 저장
  const [myHolidayList, setMyHolidayList] = useState([]);
  const [reasonList, setResonList] = useState([]); // 사유 콤보 리스트 저장
  const [reasonValue, setReasonValue] = useState(""); // 사유 선택 저장
  const gubunList = useRef([
    { value: "2", text: "결근계" },
    { value: "3", text: "연차" },
  ]); // 휴가 구분 리스트 저장
  const [gubunValue, setGubunValue] = useState("2"); // 휴가 구분 선택 저장
  const [holidayDetailList, setHolidayDetailList] = useState([]); // 현재 등록된 휴가 상세 데이터 저장
  const [dialogToggle, setDialogToggle] = useState(false);
  const [dialogDateValue, setDialogDateValue] = useState(new Date());
  const [dialogToggle1, setDialogToggle1] = useState(false);
  const deleteDatas = useRef({});

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await SelectLogic(); // 사유 데이터 조회
      await SelectLogic1(); // 현재 등록된 휴가 조회
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 사유 데이터 조회
  const SelectLogic = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.GetCode,
        {
          code: "RSTDE_REQST_REASON",
          key1: "",
          key2: "",
          key3: "",
          key4: "",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("사유 데이터 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          setResonList([...data]);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 현재 등록된 휴가 조회
  const SelectLogic1 = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _holidayList = [];
    let _myHolidayList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Holiday.Holiday,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("현재 등록된 휴가 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setHolidayList([]);
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _holidayList.push({
              day: Commons.DateFormating(data[i].startdate, 2),
              count: data[i].cnt,
            });
            if (data[i].icnt == 1) {
              _myHolidayList.push(Commons.DateFormating(data[i].startdate, 2));
            }
          }
          setHolidayList(_holidayList);
          setMyHolidayList(_myHolidayList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 현재 등록된 휴가 상세 조회
  const SelectLogic2 = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _holidayDetailList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Holiday.GetDetail,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("현재 등록된 휴가 상세 조회: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setHolidayDetailList([]);
          setDialogToggle(false);
          throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _holidayDetailList.push(data[i]);
          }
          setHolidayDetailList(_holidayDetailList);
          setDialogToggle(true);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 휴가 신청
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (!reasonValue) {
        throw new Error("사유를 선택하세요.");
      }
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Holiday.Create,
        {
          dt: Commons.DateFormating(dateValue, 6),
          userId: "user",
          seq: 0,
          rstdeDiv: gubunValue,
          reqstResn: reasonValue,
          processDiv: "0",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("휴가 신청: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic1();
          setGubunValue("2");
          setReasonValue("");
          SelectLogic();
          Commons.Toast("success", "신청되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 휴가 취소
  const DeleteLogic = async (_params) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Holiday.Delete,
        _params
      ).then((result) => {
        let data = result.data;
        // console.log("휴가 취소: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic1();
          SelectLogic2();
          setDialogToggle1(false);
          Commons.Toast("success", "취소되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Calendar
        holidays={holidayList}
        myHolidays={myHolidayList}
        dateState={dateValue}
        onChange={async (e) => {
          setDateValue(e);
          await SelectLogic1(Commons.DateFormating(e, 8));
        }}
        onActiveStartDateChange={async (e) => {
          setDateValue(e);
          await SelectLogic1(Commons.DateFormating(e, 8));
        }}
      />
      <Card className="mt-3">
        <Card.Body className="input-card-body">
          <Dropdown
            variant="outline-primary"
            title="사유를 선택하세요."
            items={reasonList}
            value={reasonValue}
            onChange={(e) => setReasonValue(e)}
          />
        </Card.Body>
        <Card.Body className="input-card-body input-card-body___flex_space_between_center">
          <p>구분</p>
          <ButtonRadio
            items={gubunList.current}
            checked={gubunValue}
            onChange={(e) => setGubunValue(e)}
          />
        </Card.Body>
        <Card.Body className="input-card-body input-card-body___flex_space_between_center">
          <Button
            className="vacation-button___width"
            title="신청"
            onClick={SaveLogic}
          />
          <Button
            className="vacation-button___width"
            title="휴무 조회"
            onClick={SelectLogic2}
          />
        </Card.Body>
      </Card>
      <Dialog
        header={false}
        fullscreen
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButton={false}
      >
        <Calendar
          navClassName="custom-react-calendar-nav"
          todayButtonYn={false}
          dateState={dialogDateValue}
          // onChange={(e) => console.log(e)}
          onActiveStartDateChange={(e) =>
            SelectLogic2(Commons.DateFormating(e, 8))
          }
        />
        <Card>
          <Card.Body className="custom-table-grid-header">
            <Stack direction="horizontal">
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-48">
                순번
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-80">
                일자
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-128">
                사유
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-64">
                승인
              </div>
            </Stack>
          </Card.Body>
        </Card>
        <div className="custom-table-grid-datas">
          {holidayDetailList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-grid-body">
                  <Stack direction="horizontal">
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-48">
                      {item.num}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-80">
                      {item.dd}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-128">
                      {
                        reasonList.filter((f) => f.value == item.reqstResn)[0]
                          .text
                      }
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-64">
                      {item.processNm == "신청" ? (
                        <Button
                          size="sm"
                          title="취소"
                          onClick={() => {
                            deleteDatas.current = { ...item };
                            setDialogToggle1(true);
                          }}
                        />
                      ) : (
                        item.processNm
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Dialog>
      <Dialog
        title="휴무 취소"
        show={dialogToggle1}
        onHide={() => setDialogToggle1(false)}
        sumitButtonName="확인"
        onSumit={() => DeleteLogic(deleteDatas.current)}
      >
        <p>{`${deleteDatas.current.dd}일 휴가를`}</p>
        <p>취소하시겠습니까?</p>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default Holiday;
